import { render, staticRenderFns } from "./tableDetail.vue?vue&type=template&id=6524f01b&scoped=true"
import script from "./tableDetail.vue?vue&type=script&lang=js"
export * from "./tableDetail.vue?vue&type=script&lang=js"
import style0 from "./tableDetail.vue?vue&type=style&index=0&id=6524f01b&prod&lang=scss&scoped=true"
import style1 from "./tableDetail.vue?vue&type=style&index=1&id=6524f01b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6524f01b",
  null
  
)

export default component.exports